import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { LoginContextData } from "../Declarations";
import { IResetPasswordRequest, useResetPassword } from "../hooks/useResetPassword";
import { useState } from "react";

interface IResetPasswordProps {
    data: LoginContextData;
    onReset: () => void;
}

export const ResetPassword = ({ data, onReset }: IResetPasswordProps) => {
    const [newPassword, setNewPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [error, setError] = useState<string | null>(null);

    // Narrow the values to satisfy hook input
    const BrowserFingerprint: string = data.BrowserFingerprint !== undefined ? data.BrowserFingerprint : "";
    const username: string = data.UserName !== undefined ? data.UserName : "";
    const password: string = data.Password !== undefined ? data.Password : "";
    const UserID: number = data.UserID !== undefined ? data.UserID : 0;
   // const NewPassword: string = data.NewPassword !== undefined ? data.NewPassword : "";

    const resetMutation = useResetPassword();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        const payload: IResetPasswordRequest = {
            BrowserFingerprint: BrowserFingerprint,
            NewPassword: newPassword,
            Password: password,
            UserAgent: navigator.userAgent,
            UserID: UserID,
            UserName: username,
        };

        resetMutation.mutate(
            payload,
            {
                onError: (err: unknown) => {
                    let message = "Password reset failed";
                    if (typeof err === "object" && err !== null && "message" in err) {
                        message = String((err as any).message);
                    }
                    setError(message);
                },
                onSuccess: () => {
                    onReset();
                },
            }
        );
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Typography sx={{ fontWeight: "bold" }} variant="h5">Reset Your Password</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <form onSubmit={handleSubmit}>

                    <Stack spacing={2} sx={{ alignItems: "center" }}>
                        <TextField
                            fullWidth={true}
                            label="New Password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />

                        <TextField
                            fullWidth={true}
                            label="Confirm New Password"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />

                        {error !== null && <p className="error">{error}</p>}

                        <Button
                            color="primary"
                            disabled={resetMutation.isPending}
                            fullWidth={false}
                            sx={{ width: "50%" }}
                            type="submit"
                            variant="contained"
                        >
                            {resetMutation.isPending ? "Submitting..." : "Reset Password"}
                        </Button>
                    </Stack>
                </form>
            </Grid>
        </Grid>
    );
};
